import { AlertCircle } from 'lucide-react'

export const IntegrationError = (error: any) => {
  return (
    <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
    <div className="flex items-center">
      <AlertCircle className="h-5 w-5 text-red-500 mr-2" />
      <span className="text-lg font-semibold text-red-700">
        Error Loading Connections
      </span>
    </div>
    <p className="mt-2 text-red-600">
      {(error as Error).message}
    </p>
    <p className="mt-1 text-sm text-red-500">
      Please try refreshing the page. If the problem persists, contact
      support.
    </p>
  </div>
  )
}